import styled from 'styled-components';
import { AppBaseSelect } from 'components/atoms';

export const Container = styled.div`
    display: flex;
    align-items: flex-end;
    gap: ${({ theme }) => theme.sizes.marginNormal}px;
    flex-wrap: wrap;
`;

export const StyledSelect = styled(AppBaseSelect)`
    .ant-select-selector .ant-select-selection-item {
        padding-inline-end: 30px;
    }
`;
